import { type IAsyncExecStatusResult } from '@inpart-io/devtools-iap';
import { type MutationTree } from 'vuex';

import { type IImportStatusState } from './types';

export const RECEIVE_STATUS_RESULT = 'RECEIVE_STATUS_RESULT';

export const mutations: MutationTree<IImportStatusState> = {
    [RECEIVE_STATUS_RESULT](_state, { statusId, statusResult }: { statusId: string; statusResult: IAsyncExecStatusResult }) {
        _state.asyncTaskStatus.set(statusId, statusResult);
    }
};
